// removed by extract-text-webpack-plugin
module.exports = {"flex":"Flex-flex-2VnwN","flexItem":"Flex-flexItem-3bLMj","flexRow":"Flex-flexRow-3Smd3"};


//////////////////
// WEBPACK FOOTER
// ./modules/issFrontend/styles/Flex.styl
// module id = ./modules/issFrontend/styles/Flex.styl
// module chunks = 1